export default {
  TimesPluralization: 'Time | Times',
  PointsPluralization: 'Point | Points'
}
